/* =====================================================================
 * Product Slider
 * =====================================================================
 * 1. Main Slider
 * 2. Content Slider
 * 3. Background Slider
 * 4. Next Product Slider
 * 5. Controls/Sync
 * ===================================================================*/

import { tns } from 'tiny-slider/src/tiny-slider';

(function (doc) {

  /* ---------------------------------------------------------------------
   * 1. Main Slider
   * -------------------------------------------------------------------*/

  const mainSliderContainer = doc.querySelector('.mainSlider');
  if (!mainSliderContainer) return;

  const mainSlider = new tns({
    nav: false,
    speed: 1200,
    touch: false,
    controls: false,
    preventScrollOnTouch: 'auto',
    container: mainSliderContainer,
  });

  /* ---------------------------------------------------------------------
   * 2. Content Slider
   * -------------------------------------------------------------------*/

  const contentSliderContainer = doc.querySelector('.contentSlider');
  if (!contentSliderContainer) return;
  const contentSlider = new tns({
    nav: false,
    speed: 1200,
    touch: false,
    controls: false,
    preventScrollOnTouch: 'auto',
    container: contentSliderContainer
  });

  /* ---------------------------------------------------------------------
   * 3. Background Slider
   * -------------------------------------------------------------------*/

  const bgSliderContainer = doc.querySelector('.bgSlider');
  if (!bgSliderContainer) return;
  const bgSlider = new tns({
    nav: false,
    speed: 1200,
    touch: false,
    controls: false,
    preventScrollOnTouch: 'auto',
    container: bgSliderContainer
  });

  /* ---------------------------------------------------------------------
   * 4. Next Product Slider
   * -------------------------------------------------------------------*/

  const nextSliderContainer = doc.querySelector('.nextSlider');
  if (!nextSliderContainer) return;
  const nextSlider = new tns({
    nav: false,
    speed: 1200,
    touch: false,
    startIndex: 1,
    controls: false,
    axis: 'vertical',
    preventScrollOnTouch: 'auto',
    container: nextSliderContainer
  });

  /* ---------------------------------------------------------------------
   * 5. Controls/Sync
   * -------------------------------------------------------------------*/

  const sliderControl = doc.querySelector('.btnNext');
  if (!sliderControl) return;

  const updateControlColor = (currentSlide) => {
    const color = currentSlide.dataset.color;
    sliderControl.style.backgroundColor = color;
  };

  const info = contentSlider.getInfo();
  updateControlColor(info.slideItems[1]);

  sliderControl.addEventListener('click', () => {
    [contentSlider, bgSlider, mainSlider, nextSlider].forEach((slider) => {
      slider.goTo('next');
    });

    const info = contentSlider.getInfo();
    updateControlColor(info.slideItems[info.index]);
  });

}(document));
